import { render, staticRenderFns } from "./ProductRow.vue?vue&type=template&id=3a0e1b78&scoped=true"
import script from "./ProductRow.vue?vue&type=script&lang=js"
export * from "./ProductRow.vue?vue&type=script&lang=js"
import style0 from "./ProductRow.vue?vue&type=style&index=0&id=3a0e1b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0e1b78",
  null
  
)

export default component.exports